/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { RouterModule, Routes } from '@angular/router';
// Components
import { TopNavComponent } from './components/top-nav/top-nav.component';

// Guards
import { inject, NgModule } from '@angular/core';
import { AdminBlotterComponent } from './components/blotter/admin-blotter/admin-blotter.component';
import { LoginComponent } from './components/login/login.component';
import { SsoErrorComponent } from './components/login/sso-error/sso-error.component';
import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { NonAdminGuard } from './guards/nonAdmin.guard';
import { AppRoute } from './models/app.routes.model';
import { UserLayoutManagerService } from './services/user-layout-manager/user-layout-manager.service';

// ----------------- //
// Live Admin Routes //
// ----------------- //
// Member View
// Reports
// Reports/:reportId
// FX Rates

// ------------------ //
// Live Member Routes //
// ------------------ //
// Pools
// Reports
// Reports/:reportId

export const ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },

  {
    path: 'sso-error',
    component: SsoErrorComponent,
  },
  {
    path: '',
    redirectTo: '/pools',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: TopNavComponent,
    resolve: {
      userLayout: () => inject(UserLayoutManagerService).initializeLayout(),
    },
    children: [
      {
        path: 'pools',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/pools/pools.module').then((m) => m.PoolssModule),
      },
      {
        path: 'settings',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/audit/audit.module').then((m) => m.AuditModule),
      },
      {
        path: 'admin-settings',
        canActivate: [AdminGuard],
        loadChildren: () =>
          import('./components/settings/settings.module').then(
            (m) => m.SettingsCModule,
          ),
      },
      {
        path: 'member-view',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/pools/pools.module').then((m) => m.PoolssModule),
      },
      {
        path: 'rates',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/wm-rates/rates.module').then(
            (m) => m.RatesModule,
          ),
      },
      {
        path: 'credit',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/credit/credit.module').then(
            (m) => m.CreditModule,
          ),
      },
      {
        path: 'credit-limits',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/credit-bank-limits/credit-limits.module').then(
            (m) => m.CreditBankLimitsModule,
          ),
      },
      {
        path: 'reports',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/reports/reports.module').then(
            (m) => m.ReportsModule,
          ),
      },
      {
        path: 'trade-reconciliation',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/trade-reconciliation/trade-reconciliation.module').then(
            (m) => m.TradeReconModule,
          ),
      },
      {
        path: AppRoute.Blotter,
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/blotter/blotter.module').then(
            (m) => m.BlotterModule,
          ),
      },
      {
        path: 'pricer',
        canActivate: [NonAdminGuard],
        loadChildren: () =>
          import('./components/blotter/pricer.module').then(
            (m) => m.PricerModule,
          ),
      },
      {
        path: 'admin-blotter',
        canActivate: [AdminGuard],
        component: AdminBlotterComponent,
        children: [
          {
            path: 'blotter',
            canActivate: [NonAdminGuard],
            loadChildren: () =>
              import('./components/blotter/blotter.module').then(
                (m) => m.BlotterModule,
              ),
          },

          {
            path: 'pricer',
            canActivate: [NonAdminGuard],
            loadChildren: () =>
              import('./components/blotter/pricer.module').then(
                (m) => m.PricerModule,
              ),
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
